import {post} from '../../request'

/**
 * 查询列表
 * @param data
 * @returns {Promise<*>}
 */
export function getQueryList(data) {
    return post("/admin/Querymenu/index", data)
}

/**
 * 状态启用
 * @param data
 * @returns {Promise<*>}
 */
 export function is_online(data) {
    return post("/admin/Querymenu/is_online", data)
}

/**
 * 编辑
 * @param data
 * @returns {Promise<*>}
 */
 export function queryEdit(data) {
    return post("/admin/Querymenu/edit", data)
}

